import React from 'react';
import { Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import HoverMarkdownContainer from '@/components/wrappers/HoverMarkdownContainer';
import { editUserGroup, updateUserGroupProperties } from '../actions/usergroups/update';

const UserGroupDescription = ({
  canEdit,
  category,
  code,
  description,
  isEditing,
  onChange,
  showEdit,
  validationErrors,
}) => {
  if (!canEdit && !description) {
    return null;
  }

  const validationError = findError(validationErrors, 'usergroup', [fields.DESCRIPTION]);

  return (
    <Container fluid className="aridhia-usergroup-description">
      <ValidationSpan validationError={validationError} />
      {!isEditing && (
        <HoverMarkdownContainer
          canEdit={canEdit}
          showEdit={() => showEdit(category, code)}
          value={description}
          editText="click.to.edit.description"
          position="top"
          toolTip="bottom right"
          editCopyMods="field-container"
          as="h2"
          className="aridhia-usergroup-list-container aridhia-h3"
        />
      )}
      {canEdit && isEditing && (
        <MarkdownEditor
          id="usergroup_description"
          value={description || ''}
          onChange={(value) => onChange(category, code, { description: value })}
          maxEditorHeight={100}
          minPreviewHeight={90}
          className={validationClasses(validationError, 'aridhia-h3 aridhia-is-edit-mode ')}
        />
      )}
    </Container>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { usergroups: { update } } } },
  userGroups: { userGroups },
}, { category, code }) => {
  const item = findResult(userGroups, category, code);

  return {
    canEdit: update,
    description: item?.description,
    isEditing: item?.isEditing,
    validationErrors: item?.saveErrors,
  };
};

const mapDispatchToProps = {
  showEdit: editUserGroup,
  onChange: updateUserGroupProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupDescription);
